import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminDashboard from './pages/AdminDashboard';
import StudentDashboard from './pages/StudentDashboard';
import CoachDashboard from './pages/CoachDashboard';
import ParentDashboardPage from './pages/ParentDashboard';
import PublicSessions from './pages/PublicSessions';
import PublicCourseDetail from './pages/PublicCourseDetail';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import VisualCodeCanvas from './components/classroom/VisualCodeCanvas';
import CodeTikTok from './components/classroom/CodeTikTok';
import Marketplace from './pages/Marketplace';
import BecomeInstructor from './pages/BecomeInstructor';
import MetaverseWorld from './components/metaverse/MetaverseWorld';
import InteractiveLibrary from './pages/InteractiveLibrary';
import Footer from './components/Footer';
import { UserProvider } from './context/UserContext';
import { DataProvider } from './context/DataContext';

function App() {
  return (
    <UserProvider>
      <DataProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sessions" element={<PublicSessions />} />
            <Route path="/course/:courseId" element={<PublicCourseDetail />} />
            <Route path="/code-canvas" element={<VisualCodeCanvas />} />
            <Route path="/code-tiktok" element={<CodeTikTok />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/become-instructor" element={<BecomeInstructor />} />
            <Route path="/metaverse" element={<MetaverseWorld />} />
            <Route path="/interactive-library" element={<InteractiveLibrary />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/student/*" element={<StudentDashboard />} />
            <Route path="/coach/*" element={<CoachDashboard />} />
            <Route path="/parent/*" element={<ParentDashboardPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </Router>
      </DataProvider>
    </UserProvider>
  );
}

export default App;

